attachEvent('.menu__arrow', 'click', (el) => {
  const item = el.target.closest('.menu__item');
  const dropdown = item.querySelector('.menu__dropdown');
  if (dropdown) {
    item.classList.toggle('is-open-submenu');
    slideToggle(dropdown, 300, 'block');
  }
});

window.addEventListener('DOMContentLoaded', () => {
  const dropdownEle = document.querySelector('.menu__list.level-2');
  const dropdownHeight = dropdownEle?.offsetHeight || 0;
  dropdownEle?.style.setProperty('--dropdown-height', `${dropdownHeight}px`);
});
